var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"motor-recommendations",class:_vm.device},[_c('motor-list',{on:{"openModal":function($event){return _vm.$emit('openModal')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }